import { render, staticRenderFns } from "./Parents.vue?vue&type=template&id=3831ec1e"
import script from "./Parents.vue?vue&type=script&lang=ts"
export * from "./Parents.vue?vue&type=script&lang=ts"
import style0 from "./Parents.vue?vue&type=style&index=0&id=3831ec1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports